import { ucFirst } from "@blocks/utils";
import { dispatch, useSelect } from "@wordpress/data";
import { useCallback, useEffect } from "react";
import { deviceStore } from "../store/device-store";

type device = "desktop" | "tablet" | "mobile";

declare var wp: any;
declare var pagenow: any;

const useDevice = (): {
	device: device;
	setDevice: (device: device) => void;
} => {
	const store: typeof pagenow extends "site-editor"
		? "core/edit-site"
		: "core/edit-post" =
		"site-editor" === pagenow ? "core/edit-site" : "core/edit-post";

	useEffect(() => {
		wp?.customize?.previewedDevice?.bind((v: string) => {
			// @ts-ignore
			dispatch(deviceStore).setDevice(v);
		});
	}, []);

	const device: device = useSelect(
		(select: any) =>
			select(store)
				?.__experimentalGetPreviewDeviceType()
				?.toLowerCase() ??
			select(deviceStore)?.getDevice() ??
			"desktop",
		[]
	);

	const setDevice = useCallback(
		(deviceType: device) => {
			// @ts-ignore
			(dispatch(store) as any)?.__experimentalSetPreviewDeviceType(
				ucFirst(deviceType)
			);
			// @ts-ignore
			dispatch(deviceStore).setDevice(deviceType);
			wp?.customize?.previewedDevice(deviceType);
		},
		[store]
	);

	return { device, setDevice };
};

export default useDevice;
